import React from "react";
import { Logo } from "./Logo";
import { Award, Target, Cpu, Compass, Users } from "lucide-react";

export default function PageSwitcher({ activePage, onPageChange, totalLeads = 0 }) {
  const tabs = [
    { id: "resume-pain", label: "Page A: Resume Pain", color: "border-blue-600 text-blue-600 bg-blue-500/5", icon: <Award className="h-4 w-4" /> },
    { id: "interview-fear", label: "Page B: Interview Fear", color: "border-red-600 text-red-600 bg-red-500/5", icon: <Target className="h-4 w-4" /> },
    { id: "experience-gap", label: "Page C: Experience Gap", color: "border-emerald-600 text-emerald-500 bg-emerald-500/5", icon: <Cpu className="h-4 w-4" /> },
    { id: "career-confusion", label: "Page D: Career Confusion", color: "border-purple-500 text-purple-400 bg-purple-500/5", icon: <Compass className="h-4 w-4" /> }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-slate-950/80 backdrop-blur-xl border-b border-slate-900 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between py-3 gap-3">
          
          {/* Logo Brand */}
          <div className="flex items-center justify-between">
            <Logo className="h-10 w-10 text-white" />
            <button
              onClick={() => onPageChange("admin-leads")}
              className={`md:hidden flex items-center gap-1.5 px-3 py-1.5 bg-indigo-500/10 hover:bg-indigo-500/20 text-indigo-400 font-black text-xs uppercase rounded-lg border border-indigo-500/20 transition-all ${
                activePage === "admin-leads" ? "bg-indigo-500/30 text-white border-indigo-400" : ""
              }`}
              data-testid="mobile-admin-dashboard-tab"
            >
              <Users className="h-3.5 w-3.5" /> Leads ({totalLeads})
            </button>
          </div>

          {/* Strategy Pages Switcher Tabs */}
          <nav className="flex flex-wrap items-center gap-1.5" data-testid="page-switcher-navigation">
            {tabs.map((tab) => {
              const isActive = activePage === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => onPageChange(tab.id)}
                  className={`flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-black uppercase tracking-wider transition-all duration-200 border ${
                    isActive 
                      ? tab.color + " shadow-md" 
                      : "bg-slate-900/50 border-slate-800 text-slate-400 hover:text-white hover:bg-slate-800/30"
                  }`}
                  data-testid={`page-switcher-tab-${tab.id}`}
                >
                  {tab.icon} {tab.label}
                </button>
              );
            })}
          </nav>

          {/* Leads Simulation Dashboard Link */}
          <div className="hidden md:flex items-center">
            <button
              onClick={() => onPageChange("admin-leads")}
              className={`flex items-center gap-1.5 px-4 py-2 bg-indigo-500/10 hover:bg-indigo-500/20 text-indigo-400 font-black text-xs uppercase rounded-xl border border-indigo-500/20 transition-all ${
                activePage === "admin-leads" ? "bg-indigo-500/30 text-white border-indigo-400" : ""
              }`}
              data-testid="admin-dashboard-tab"
            >
              <Users className="h-4 w-4" /> Leads Dashboard ({totalLeads})
            </button>
          </div>

        </div>
      </div>
    </header>
  );
}
